<template>
	<Slider />
	<Sections />
	<!-- <BrandSlider /> -->
	<SitePrior />
	<SubscriptionModal />
	<Footer />
</template>

<script>
	import Slider from "../components/Slider/Slider.vue";
	import Sections from "../components/Sections/Sections.vue";
	import BrandSlider from "../components/Bottom/BrandSlider.vue";
	import SitePrior from "../components/Bottom/SitePrior.vue";
	import Footer from "../components/Bottom/Footer.vue";
	import {mapGetters, mapActions} from "vuex";
	import SubscriptionModal from "../components/Modals/SubscriptionModal.vue";

	export default {
		name: "Home",
		components: {
			Slider,
			Sections,
			Footer,
			BrandSlider,
			SitePrior,
			SubscriptionModal,
		},
		data() {
			return {
				showModal: false,
			};
		},

		methods: {
			...mapActions("cat", ["fetchCategories"]),
		},
		async mounted() {
			let recaptchaScript = document.createElement("script");
			recaptchaScript.setAttribute("src", "assets/js/app.js");
			document.head.appendChild(recaptchaScript);
			console.log("Home Compo");
		},
	};
</script>
